<template>
    <div class="page-header">
        <!-- 一级菜单 -->
        <div class="header-nav-1">
          <div class="page-main-box clearfix">
              <div class="header-account">
                <span :title="companyName">{{companyName}}</span>
              </div>
              <div class="header-nav" v-if="type == 1">
                <ul>
                  <li v-for="(item,index) in nav" :key="index"><a :href="item.path" :class="item.appName == appName?'cur':''">{{item.name}}</a></li>
                </ul>
              </div>
              <div class="header-tools" v-if="type == 1">
                <a class="back-old-version" :href="oldVersionHref">返回旧版</a>
                <div class="message-link" @click="goMessages">
                  <i class="iconfont icon-liaotian1"></i>
                </div>
                <!-- <Poptip trigger="hover" width="400" placement="bottom-end">
                  <div class="message-link">
                    <i class="iconfont icon-liaotian1"></i>
                  </div>
                  <div class="api" slot="content">
                    <ul class="message-tip" @click="goMessages">
                      <li v-if="messageInfo.positionOutPositionTitle && messageInfo.positionOutPositionAssign">您的职位<span class="text-ellipse position-name mlr5" :title="messageInfo.positionOutPositionTitle">{{messageInfo.positionOutPositionTitle}}</span>已经交给<span class="text-ellipse name mlr5" :title="messageInfo.positionOutPositionAssign">{{messageInfo.positionOutPositionAssign}}</span>继续招聘</li>
                      <li v-if="messageInfo.positionInPositionTitle && messageInfo.positionInPositionAssign"><span class="text-ellipse name mr5" :title="messageInfo.positionInPositionAssign">{{messageInfo.positionInPositionAssign}}</span>已将职位<span class="text-ellipse position-name mlr5" :title="messageInfo.positionInPositionTitle">{{messageInfo.positionInPositionTitle}}</span>转交给您继续招聘</li>
                      <li v-if="messageInfo.resumeInPositionCount && messageInfo.resumeInPositionCount!='0'">您有<span class="mlr5">{{messageInfo.resumeInPositionCount}}</span>个职位收到了简历推送，请<span>立即查看</span></li>
                      <li v-if="messageInfo.resumeFeedbackCount && messageInfo.resumeFeedbackCount!='0'">您有<span class="mlr5">{{messageInfo.resumeFeedbackCount}}</span>个新应聘反馈，请<span>立即查看</span></li>
                      <li class="no-message" v-if="!messageInfo.positionOutPositionTitle && !messageInfo.positionOutPositionAssign && !messageInfo.positionInPositionTitle && !messageInfo.positionInPositionAssign && (!messageInfo.resumeInPositionCount || messageInfo.resumeInPositionCount=='0') && (!messageInfo.resumeFeedbackCount || messageInfo.resumeFeedbackCount=='0')">-没有新消息-</li>
                    </ul>
                  </div>
                </Poptip> -->
                
                <!-- <i class="iconfont icon-xiaoxi5"></i> -->
                
                  <Dropdown @on-click="handDropFun" class="cname-drop" placement="bottom-end">
                      <div class="cname">
                        <img v-if="userLogo" :src="userLogo" />
                        <span :class="'s-name sex-'+gender" v-if="!userLogo">{{surname}}</span>
                        <span class="u-name">{{userName}}&nbsp;&nbsp;<Icon type="arrow-down-b"></Icon></span>
                      </div>
                      <DropdownMenu slot="list">
                          <DropdownItem name="setting"><a class="link-black-color" href="account.html#/info">账户设置</a></DropdownItem>
                          <DropdownItem name="points"><a class="link-black-color" href="account.html#/points">我的积分</a></DropdownItem>
                          <DropdownItem name="logout">退出</DropdownItem>
                      </DropdownMenu>
                  </Dropdown>
              </div>
          </div>
        </div>
        <!-- 二级菜单 -->
        <div class="header-nav-2" v-if="isShowSub">
          <div class="page-main-box clearfix">
            <router-link  v-for="(item,index) in subNavList" :key="index" v-if="item.show" tag="a" active-class="cur" :to="{path:'/'+item.pathName+''}">{{item.name}}</router-link>
          </div>
        </div>
    </div>
</template>
<script>
import DB from "@/common/db"
import Storage from '@/common/storage'
export default {
  name: "headers",
  data() {
    return {
      nav: _vms_hr_data.nav,
      subNav:_vms_hr_data.subNav,
      subNavList:[],
      subNavObj:{},
      userLogo: null,
      userName: null,
      messageInfo: {},
      surname: null,
      gender: 1,
      isShowSub:false,
      pname:null,
      companyName:null,
      oldVersionHref: '',
      accessToken: Storage.getCookie('accessToken') ? Storage.getCookie('accessToken') : ''
    };
  },
  props: {
    type: {
      type: Number,
      default: 1
    },
    appName: {
      type: String,
      default: null
    },
    user: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },

  methods: {
    handDropFun(name){
      if(name == 'logout'){
        DB.request({
            url: DB.prefix + 'auth/v2/logout',
            success(){
                window.location.href = '/'
            }
        });
      };
    },
    goMessages() {
      window.location.href = 'account.html#/messages'
    },
    getMessages() {
      DB.request({
        url: DB.prefix + "biz/package/msg/getTopView",
        success: data => {
          this.messageInfo = data.data ? data.data : {};
        }
      });
    },
    isShowSubNav(){
      if(this.appName=="positions"){
        if (window.normalPositionFlag && ['hunter/publish','normal/publish','publish/type'].indexOf(this.pname) == -1) {
          this.isShowSub = true;
        }else{
          this.isShowSub = false;
        }
      }else{
        if(this.subNavObj[this.pname]){
          this.isShowSub = true;
        }else{
          this.isShowSub = false;
        }
      }
      
    },
    setSubNav(app){
      if(this.subNav[app] && this.subNav[app].length > 0){
        this.subNavList = this.subNav[app];
        
        this.subNavList.forEach((item)=>{
          this.subNavObj[item.pathName] = true;
        });
        this.isShowSubNav();
      }else{
        this.isShowSub = false;
      }
    }
  },
  watch: {
    '$route.name'(n,o){
      this.pname = n;
      this.isShowSubNav();      
    }
  },
  components: {},
  created() {
    if (this.type == 1) {
      this.userLogo = this.user.userDetail.profile.avatar || null;
      this.userName = this.user.userDetail.profile.displayName;
      this.surname = this.userName.slice(0, 1) || "";
      this.gender = this.user.userDetail.profile.gender || 1;
      this.companyName = this.user.enterprise.displayName ||  this.user.enterprise.name || this.user.enterprise.shortName;
      this.pname = this.$route.name;
      
      this.getMessages();
      this.setSubNav(this.appName);
    }

    this.oldVersionHref = '';
    let oldVersionDomain = '';
    if(window.location.host.indexOf('test') != -1){
        oldVersionDomain = 'http://hr2test.hunteron.com';
    }else if(window.location.host.indexOf('uat') != -1){
        oldVersionDomain = 'http://hr2uat.hunteron.com';
    }else{
        oldVersionDomain = 'http://hr.hunteron.com';
    }
    this.oldVersionHref = `${oldVersionDomain}/page/transit/transit.html?accessToken=${this.accessToken}&userId=${this.user.userId}`;
  },
  mounted() {}
};
</script>
<style lang="scss">
    .cname-drop {
      .ivu-select-dropdown {
        margin-top:36px;
      }
      a.link-black-color{
        color: #495060;
      }
    }
</style>
<style lang="scss" scoped>
.page-header {
  font-size: 14px;
  width: 100%;
  .header-nav-1 {
    height: 36px;
    background: #1d2538;
    color: #bbbec4;
  }
  .header-nav-2 {
    height: 52px;
    line-height:52px;
    background: #fff;
    color:#495060;
    text-align: center;
    border-bottom:1px solid #dddee1;
    a {
      margin:0 25px;
      color:#495060;
      padding-bottom:15px;
    }
    a.cur {
      border-bottom:2px solid #2D8CF0;
      
    }
  }
  .header-account {
    float: left;
    max-width: 150px;
    line-height: 36px;
    height:36px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    margin-right:70px;
  }
  .header-nav {
    float: left;
    li {
      float: left;
      line-height: 36px;
      a {
        color: #bbbec4;
      }
      a.cur {
        color: #fff;
      }
      a:hover {
        color: #fff;
      }
      margin-right: 40px;
    }
  }
  .header-tools {
    float: right;
    height: 36px;
    line-height: 36px;
    .back-old-version{
      float: left;
      margin-right: 20px;
      color: #bbbec4;
      &:hover {
        color: #fff;
      }
    }
    .message-link,
    .ivu-poptip {
      float: left;
    }
    .message-tip {
      width: 100%;
      li {
        padding: 0 20px;
        line-height: 36px;
        height: 36px;
        font-size: 14px;
        border-bottom: solid 1px #dfdfdf;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        color: #808190;
        cursor: pointer;
        span {
          color: #2d8cf0;
          display: inline-block;
        }
        .mlr5 {
          margin: 0 5px;
        }
        .mr5 {
          margin-right: 5px;
        }
        .text-ellipse {
          text-overflow: ellipsis;
          white-space: nowrap;
          vertical-align: middle;
          overflow: hidden;
        }
        .position-name {
          max-width: 100px;
        }
        .name {
          max-width: 60px;
        }
        &:last-child {
          border: 0;
        }
      }
      .no-message {
        height: 100px;
        line-height: 100px;
        text-align: center;
      }
    }
    .iconfont {
      float: left;
      font-size: 20px;
      margin-right: 20px;
      color: #797f8c;
      cursor: pointer;
    }
    .cname {
      padding-left: 22px;
      float: left;
      color: #afb5c0;
      cursor: pointer;
      height:36px;
      img {
        width: 22px;
        float: left;
        margin-left: -22px;
        border-radius: 50%;
        margin-top: 7px;
      }
      .s-name {
        float: left;
        width: 22px;
        height: 22px;
        text-align: center;
        line-height: 22px;
        margin-left: -22px;
        font-size: 14px;
        border-radius: 50%;
        margin-top: 7px;
        color: #fff;
      }
      .sex-1 {
        background: #adc8f1;
      }
      .sex-2 {
        background: #ffb1b5;
      }
      .u-name {
        float: left;
        margin-left: 5px;
        font-size: 12px;
        color: #7c7c7c;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue